import {
  FooterLinkDto,
  ReferentielSearchResultDtoFooterLinkDto,
} from 'lib_api/lib/api/gen';

import { FetchDataResult } from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';

import { FilterDashboardFooterLink } from '../types';

export function useSearchFooterLink(
  filter: FilterDashboardFooterLink,
): [
  () => Promise<ReferentielSearchResultDtoFooterLinkDto>,
  (
    result: ReferentielSearchResultDtoFooterLinkDto,
  ) => FetchDataResult<FooterLinkDto>,
] {
  const controller = useApi().AdminFonctionnelControllerApi;

  return [
    () => {
      return controller.searchFooterLinkUsingSpecsUsingGET({
        filters: {
          ...filter,
        },
      });
    },
    result => {
      return {
        data: result.results.referenceDtoList,
        total: result.total,
      };
    },
  ];
}
